import Assessment from "@mui/icons-material/Assessment";
import Receipt from "@mui/icons-material/Receipt";
import People from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AdsClickIcon from "@mui/icons-material/AdsClick";

export const screenRoutes = [
  {
    name: "dashboard",
    path: "/dashboard",
    agentAccess: false,
    adminAccess: false,
    collaboratorAccess: true,
    auditorAccess: true,
    clientAccess: true,
    icon: <Assessment className="Sidenav__icon" fontSize="inherit" />,
  },
  {
    name: "transactions",
    path: "/transactions",
    agentAccess: true,
    adminAccess: false,
    collaboratorAccess: true,
    auditorAccess: true,
    clientAccess: false,
    icon: <Receipt className="Sidenav__icon" fontSize="inherit" />,
  },
  {
    name: "raffle",
    path: "/raffle",
    agentAccess: false,
    adminAccess: true,
    auditorAccess: true,
    clientAccess: false,
    mode: "main",
    clickable: true,
    icon: (
      <ConfirmationNumberIcon className="Sidenav__icon" fontSize="inherit" />
    ),
  },
  {
    name: "winners",
    path: "/winners",
    agentAccess: false,
    adminAccess: true,
    auditorAccess: false,
    clientAccess: false,
    mode: "main",
    clickable: true,
    icon: <EmojiEventsIcon className="Sidenav__icon" fontSize="inherit" />,
  },

  {
    name: "customers",
    path: "/customers",
    agentAccess: false,
    adminAccess: false,
    collaboratorAccess: true,
    auditorAccess: true,
    clientAccess: false,
    icon: <People className="Sidenav__icon" fontSize="inherit" />,
  },
  {
    name: "redemptions",
    path: "/redemptions",
    agentAccess: false,
    adminAccess: false,
    collaboratorAccess: true,
    auditorAccess: true,
    clientAccess: false,
    icon: <PaymentIcon className="Sidenav__icon" fontSize="inherit" />,
  },
  // {
  //   name: "Ad/Link Clicks",
  //   path: "/ads",
  //   agentAccess: false,
  //   adminAccess: false,
  //   auditorAccess: false,
  //   clientAccess: false,
  //   icon: <AdsClickIcon className="Sidenav__icon" fontSize="inherit" />,
  // },
];
